import { MyTicketsBlockCombinedProps } from './types';

const usePresenter = (props: MyTicketsBlockCombinedProps): MyTicketsBlockCombinedProps => {
  return props;
};

export default usePresenter;
